import React, { Component } from "react";
import { InputNumber, Col, Row } from "antd";

import QuerryContext from "../../../contexts/querry";

class AnswerInputNumber extends Component {
  state = {
    value: "",
  };

  ansId = "";

  static contextType = QuerryContext;

  handleChange = (event) => {
    //this.props.setHidden(event.target.value === "");
    this.context.updateAnswer(event, this.ansId);
    this.setState({ value: event });
  };

  componentDidMount = () => {
    this.props.setHidden(false);
    const answ = this.context.getAnswer(this.ansId);
    if (answ) {
      this.setState({ value: answ });
      this.props.setHidden(answ === "");
    }
  };

  render() {
    this.ansId = this.props.questId + "-text-" + this.props.aid;
    return (
      <div className="text-answer">
        <Row style={{marginTop: "5px"}}>
          <Col span={22} offset={1}>
            <Row>
            {this.props.answerData.text}:<br />
            <InputNumber
              value={this.state.value}
              min={this.props.answerData.min}
              defaultValue={this.props.answerData.min}
              max={this.props.answerData.max}
              onChange={this.handleChange}
              name={this.ansId}
            />
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}

export default AnswerInputNumber;
